<template>
  <b-input-group class="phone-input">
    <b-input-group-prepend>
      <b-dropdown
        variant="main"
        menu-class="scroll-area">
        <template slot="button-content">
          <img :src="`/static/img/flags/${activeCountry.code}.svg`">
          <div class="active-country-code">
            +{{ activeCountry.phone }}
          </div>
        </template>
        <b-dropdown-item
          v-for="country in countryList"
          :key="country.code"
          @click="choose(country)">
          <img :src="`/static/img/flags/${country.code}.svg`">
          <span>{{ country.name }}{{ country.local_name ? ` (${country.local_name})` : '' }}</span>
          <span>+{{ country.phone }}</span>
        </b-dropdown-item>
      </b-dropdown>
    </b-input-group-prepend>
    <b-input
      v-model="phone"
      :state="state"
      :formatter="format"
      :placeholder="placeholder"
      @input="onInput"/>
    <template
      v-if="showVerified && !verified && response.number === initialPhone"
      v-slot:append>
      <b-button
        v-b-tooltip.hover="verifyTooltip"
        class="verify input-group-btn"
        @click="verifyPhone">
        Click to verify
      </b-button>
      <!-- <b-input-group-text
        v-b-tooltip.hover="verifyTooltip">
        <icon
          class="text-danger"
          name="exclamation-circle"/>
      </b-input-group-text> -->
    </template>
  </b-input-group>
</template>

<style lang="scss">
.verify {
  font-size: 12px;
  padding-left: 10px;
}

.input-group-btn {
  background: $bluePrimary;
  color: white;
  border: none;

  &:hover {
    background: $bluePrimary;
  }
}
</style>

<script>
import '@/assets/css/common/_phone-input.scss';

import { format, AsYouType, isValidNumber } from 'libphonenumber-js';
import countryList from '@/helpers/lists/countries';
import getGeoLocation from '@/helpers/getGeoLocation';

export default {
  name: 'PhoneInput',
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Enter phone number',
    },
    verifyTooltip: {
      type: String,
      default: 'Phone is not verified.',
    },
  },
  data() {
    return {
      countryList,
      phone: '',
      phoneCountryCode: '',
      verified: false,
      showVerified: false,
      initialPhone: '',
      initialPhoneSet: false,
      activeCountry: {
        name: 'United States',
        local_name: null,
        code: 'US',
        phone: '1',
      },
    };
  },
  computed: {
    mode() {
      if (!this.phone) {
        return '';
      }
      if (this.phone[0] === '+') {
        return 'code';
      }
      if (this.phone[0] === '0') {
        return 'prefix';
      }
      return 'normal';
    },
    formattedResult() {
      // Calculate phone number based on mode
      if (!this.mode || !this.countryList) {
        return '';
      }
      let phone = this.phone;
      if (this.mode === 'code') {
        // If user manually type the country code
        const formatter = new AsYouType();// eslint-disable-line
        formatter.input(this.phone);

        // Find inputted country in the countries list
        // eslint-disable-next-line
        this.activeCountry = this.countryList.find(ele => ele.code === formatter.country) || this.activeCountry;
      } else if (this.mode === 'prefix') {
        // Remove the first '0' if this is a '0' prefix number
        // Ex: 0432421999
        phone = this.phone.slice(1);
      }
      return format(phone, this.activeCountry && this.activeCountry.code, 'International');
    },
    state() {
      return this.phone && this.phone.length ? isValidNumber(this.formattedResult) : null;
    },
    response() {
      const number = this.formattedResult && this.formattedResult.replace(/ /g, '');
      return {
        number,
        isValid: this.state,
        country: this.activeCountry.name,
        prefix: `+${this.activeCountry.phone}`,
      };
    },
  },
  watch: {
    state(value) {
      if (value) {
        // If mode is 'prefix', keep the number as user typed,
        // Otherwise format it
        if (this.mode !== 'prefix') {
          // this.phone = this.formattedResult;
        }
      }
    },
  },
  created() {
    if (this.value) {
      this.phone = this.value;
    }
  },
  mounted() {},
  methods: {
    setPhone(phoneCountryCode, phone, verified = false, showVerified = false) {
      this.phoneCountryCode = phoneCountryCode;
      this.phone = phone;
      this.verified = verified;
      this.showVerified = showVerified;
      this.initialPhone = this.phone;
      if (!phoneCountryCode) {
        getGeoLocation().then((response) => {
          if (response.status === 200 && response.data.country_code.length) {
            this.country = response.data.country;
            this.activeCountry = countryList.find(country => country.code === response.data.country_code) ||
              countryList.find(country => country.code === 'US');
          }
        }).catch(() => {
          this.country = 'US';
        });
      } else {
        this.activeCountry = countryList.find(country => country.phone === phoneCountryCode.replace('+', '')) || countryList.find(country => country.code === 'US');
        this.phone = this.phone.replace(phoneCountryCode, '');
      }
      this.$emit('onInput', this.response);
    },
    choose(country) {
      this.activeCountry = country;
      this.$emit('onInput', this.response);
    },
    format(value) {
      return new AsYouType(this.activeCountry.code).input(value);
    },
    onInput() {
      // Emit input event in case v-model is used in the parent
      this.$emit('input', this.response.number);

      // Emit the response, includes phone, validity and country
      this.$emit('onInput', this.response);
    },
    verifyPhone() {
      this.$emit('verifyPhone');
    },
  },
};
</script>
